
import { IonIcon } from "@ionic/react";
import { eyeOutline } from "ionicons/icons";
import React, { useContext } from "react";
import { AppContext } from "../../context/app.context";
import { QuestionnaireActionTypes } from "../../reducers/questionnaire.reducer";


const PHQViewModeButton = () => {

    const appContext = useContext(AppContext);

    const disableViewMode = () => {
        appContext.updateQuestionnaire(QuestionnaireActionTypes.EXIT_VIEW_MODE, null);
    }

    return (<IonIcon onClick={() => { disableViewMode() }} color="danger" slot="end" icon={eyeOutline} />)

}

export default PHQViewModeButton;
